import { Component, OnInit, OnDestroy } from '@angular/core';
import {Router, NavigationEnd} from '@angular/router';

import { CommercialService } from '@core/services';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy{

  showIEWarning: boolean = true;

  constructor(private _commercial: CommercialService, private router: Router){

    }
    ngOnInit(){
        this._commercial.setCommercial();
      this.router.events.subscribe((evt) => {
        if(!(evt instanceof NavigationEnd))
        {
          return;
        }
        window.scrollTo(0,0);
      })
    }

  ngOnDestroy(){

  }
}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/app.component.ts